export const symbols = [
	'BTCUSDT',
	'ETHUSDT',
	'BNBUSDT',
	'BCCUSDT',
	'NEOUSDT',
	'LTCUSDT',
	'QTUMUSDT',
	'ADAUSDT',
	'XRPUSDT',
	'EOSUSDT',
	'IOTAUSDT',
	'XLMUSDT',
	'ONTUSDT',
	'TRXUSDT',
	'ETCUSDT',
	'ICXUSDT',
	'VENUSDT',
	'NULSUSDT',
	'VETUSDT',
	'PAXUSDT',
	'BCHABCUSDT',
	'BCHSVUSDT',
	'LINKUSDT',
	'WAVESUSDT',
	'BTTUSDT',
	'ONGUSDT',
	'HOTUSDT',
	'ZILUSDT',
	'ZRXUSDT',
	'FETUSDT',
	'BATUSDT',
	'XMRUSDT',
	'ZECUSDT',
	'IOSTUSDT',
	'CELRUSDT',
	'DASHUSDT',
	'NANOUSDT',
	'OMGUSDT',
	'THETAUSDT',
	'ENJUSDT',
	'MITHUSDT',
	'MATICUSDT',
	'ATOMUSDT',
	'TFUELUSDT',
	'ONEUSDT',
	'FTMUSDT',
	'ALGOUSDT',
	'GTOUSDT',
	'ERDUSDT',
	'DOGEUSDT',
	'DUSKUSDT',
	'ANKRUSDT',
	'WINUSDT',
	'COSUSDT',
	'NPXSUSDT',
	// 'COCOSUSDT',
	'MTLUSDT',
	'TOMOUSDT',
	'PERLUSDT',
	'DENTUSDT',
	// 'MFTUSDT',
	'KEYUSDT',
	'STORMUSDT',
	'DOCKUSDT',
	'WANUSDT',
	'FUNUSDT',
	'CVCUSDT',
	'CHZUSDT',
	'BANDUSDT',
	// 'BEAMUSDT',
	'XTZUSDT',
	'RENUSDT',
	'RVNUSDT',
	'HCUSDT',
	'HBARUSDT',
	'NKNUSDT',
	'STXUSDT',
	'KAVAUSDT',
	'ARPAUSDT',
	'IOTXUSDT',
	'RLCUSDT',
	'MCOUSDT',
	'CTXCUSDT',
	'BCHUSDT',
	'TROYUSDT',
	'VITEUSDT',
	'FTTUSDT',
	'BUSDTRY',
	'EURUSDT',
	'OGNUSDT',
	'DREPUSDT',
	// 'BULLUSDT',
	// 'BEARUSDT',
	// 'ETHBULLUSDT',
	// 'ETHBEARUSDT',
	'TCTUSDT',
	'WRXUSDT',
	// 'BTSUSDT',
	'LSKUSDT',
	'BNTUSDT',
	'LTOUSDT',
	// 'EOSBULLUSDT',
	// 'EOSBEARUSDT',
	// 'XRPBULLUSDT',
	// 'XRPBEARUSDT',
	'STRATUSDT',
	// 'AIONUSDT',
	'MBLUSDT',
	'COTIUSDT',
	// 'BNBBULLUSDT',
	// 'BNBBEARUSDT',
	'STPTUSDT',
	// 'WTCUSDT',
	'DATAUSDT',
	'XZCUSDT',
	'SOLUSDT',
	'CTSIUSDT',
	'HIVEUSDT',
	'CHRUSDT',
	'GXSUSDT',
	'ARDRUSDT',
	'LENDUSDT',
	'MDTUSDT',
	'STMXUSDT',
	'KNCUSDT',
	// 'REPUSDT',
	'LRCUSDT',
	// 'PNTUSDT',
	'COMPUSDT',
	'BKRWUSDT',
	'SCUSDT',
	'ZENUSDT',
	'SNXUSDT',
	'VTHOUSDT',
	'DGBUSDT',
	'GBPUSDT',
	'SXPUSDT',
	'MKRUSDT',
	'DAIUSDT',
	'DCRUSDT',
	'STORJUSDT',
	'MANAUSDT',
	'AUDUSDT',
	'YFIUSDT',
	'BALUSDT',
	'BLZUSDT',
	'IRISUSDT',
	'KMDUSDT',
	'JSTUSDT',
	'SRMUSDT',
	'ANTUSDT',
	'CRVUSDT',
	'SANDUSDT',
	'OCEANUSDT',
	'NMRUSDT',
	'DOTUSDT',
	'LUNAUSDT',
	'RSRUSDT',
	'PAXGUSDT',
	'WNXMUSDT',
	'TRBUSDT',
	// 'BZRXUSDT',
	'SUSHIUSDT',
	// 'YFIIUSDT',
	'KSMUSDT',
	'EGLDUSDT',
	'DIAUSDT',
	'RUNEUSDT',
	'FIOUSDT',
	'UMAUSDT',
	'BELUSDT',
	'WINGUSDT',
	'UNIUSDT',
	// 'NBSUSDT',
	'OXTUSDT',
	'SUNUSDT',
	'AVAXUSDT',
	'HNTUSDT',
	'FLMUSDT',
	'ORNUSDT',
	'UTKUSDT',
	'XVSUSDT',
	'ALPHAUSDT',
	'AAVEUSDT',
	'NEARUSDT',
	'FILUSDT',
	'INJUSDT',
	'AUDIOUSDT',
	'CTKUSDT',
	'AKROUSDT',
	'AXSUSDT',
	'HARDUSDT',
	'DNTUSDT',
	'STRAXUSDT',
	'UNFIUSDT',
	'ROSEUSDT',
	'AVAUSDT',
	'XEMUSDT',
	'SKLUSDT',
	'GRTUSDT',
	'JUVUSDT',
	'PSGUSDT',
	'1INCHUSDT',
	'REEFUSDT',
	'OGUSDT',
	'ATMUSDT',
	'ASRUSDT',
	'CELOUSDT',
	'RIFUSDT',
	'BTCSTUSDT',
	'TRUUSDT',
	'CKBUSDT',
	'TWTUSDT',
	'FIROUSDT',
	'LITUSDT',
	'SFPUSDT',
	'DODOUSDT',
	'CAKEUSDT',
	'ACMUSDT',
	'BADGERUSDT',
	'FISUSDT',
	'OMUSDT',
	'PONDUSDT',
	'DEGOUSDT',
	'ALICEUSDT',
	'LINAUSDT',
	'PERPUSDT',
	'RAMPUSDT',
	'SUPERUSDT',
	'CFXUSDT',
	'EPSUSDT',
	// 'AUTOUSDT',
	'TKOUSDT',
	'PUNDIXUSDT',
	'TLMUSDT',
	// 'BTGUSDT',
	'MIRUSDT',
	'BARUSDT',
	'FORTHUSDT',
	'BAKEUSDT',
	'BURGERUSDT',
	'SLPUSDT',
	'SHIBUSDT',
	'ICPUSDT',
	'ARUSDT',
	'POLSUSDT',
	'MDXUSDT',
	'MASKUSDT',
	'LPTUSDT',
	'NUUSDT',
	'XVGUSDT',
	'ATAUSDT',
	'GTCUSDT',
	'TORNUSDT',
	'KEEPUSDT',
	'ERNUSDT',
	'KLAYUSDT',
	'PHAUSDT',
	'BONDUSDT',
	'MLNUSDT',
	'DEXEUSDT',
	'C98USDT',
	'CLVUSDT',
	'QNTUSDT',
	'FLOWUSDT',
	'TVKUSDT',
	'MINAUSDT',
	'RAYUSDT',
	'FARMUSDT',
	'ALPACAUSDT',
	'QUICKUSDT',
	'MBOXUSDT',
	'FORUSDT',
	'REQUSDT',
	'GHSTUSDT',
	'WAXPUSDT',
	'TRIBEUSDT',
	'GNOUSDT',
	'XECUSDT',
	'ELFUSDT',
	'DYDXUSDT',
	// 'POLYUSDT',
	'IDEXUSDT',
	'VIDTUSDT',
	'GALAUSDT',
	'ILVUSDT',
	'YGGUSDT',
	'SYSUSDT',
	'DFUSDT',
	'FIDAUSDT',
	'FRONTUSDT',
	'CVPUSDT',
	'AGLDUSDT',
	'RADUSDT',
	'BETAUSDT',
	'RAREUSDT',
	'LAZIOUSDT',
	'CHESSUSDT',
	'ADXUSDT',
	'AUCTIONUSDT',
	'DARUSDT',
	'BNXUSDT',
	'RGTUSDT',
	'MOVRUSDT',
	'CITYUSDT',
	'ENSUSDT',
	'KP3RUSDT',
	'QIUSDT',
	'PORTOUSDT',
	'POWRUSDT',
	'VGXUSDT',
	'JASMYUSDT',
	'AMPUSDT',
	// 'PLAUSDT',
	'PYRUSDT',
	'RNDRUSDT',
	'ALCXUSDT',
	'SANTOSUSDT',
	// 'MCUSDT',
	'ANYUSDT',
	'BICOUSDT',
	'FLUXUSDT',
	'FXSUSDT',
	'VOXELUSDT',
	'HIGHUSDT',
	'CVXUSDT',
	'PEOPLEUSDT',
	'OOKIUSDT',
	'SPELLUSDT',
	'JOEUSDT',
	'ACHUSDT',
	'IMXUSDT',
	'GLMRUSDT',
	'LOKAUSDT',
	'SCRTUSDT',
	'API3USDT',
	'BTTCUSDT',
	'ACAUSDT',
	// 'ANCUSDT',
	'XNOUSDT',
	'WOOUSDT',
	'ALPINEUSDT',
	'TUSDT',
	'ASTRUSDT',
	'GMTUSDT',
	'KDAUSDT',
	'APEUSDT',
	'BSWUSDT',
	'BIFIUSDT',
	// 'MULTIUSDT',
	'STEEMUSDT',
	'MOBUSDT',
	'NEXOUSDT',
	'REIUSDT',
	'GALUSDT',
	'LDOUSDT',
	'EPXUSDT',
	'OPUSDT',
	'LEVERUSDT',
	'STGUSDT',
	'LUNCUSDT',
	'GMXUSDT',
	'NEBLUSDT',
	'POLYXUSDT',
	'APTUSDT',
	'OSMOUSDT',
	'HFTUSDT',
	'PHBUSDT',
	'HOOKUSDT',
	'MAGICUSDT',
	'HIFIUSDT',
	'RPLUSDT',
	'PROSUSDT',
	'AGIXUSDT',
	'GNSUSDT',
	'SYNUSDT',
	'VIBUSDT',
	'SSVUSDT',
	'LQTYUSDT',
	'AMBUSDT',
	'BETHUSDT',
	'GASUSDT',
	'GLMUSDT',
	'PROMUSDT',
	'QKCUSDT',
	'UFTUSDT',
	'IDUSDT',
	'ARBUSDT',
	'LOOMUSDT',
	'OAXUSDT',
	'RDNTUSDT',
	'WBTCUSDT',
	'EDUUSDT',
	'SUIUSDT',
	'AERGOUSDT',
	'PEPEUSDT',
	'FLOKIUSDT',
	'ASTUSDT',
	'SNTUSDT',
	'COMBOUSDT',
	'MAVUSDT',
	'PENDLEUSDT',
	'TUSDTRY',
	'ARKMUSDT',
	'WBETHUSDT',
	'WLDUSDT',
	'SEIUSDT',
	'CYBERUSDT',
	'ARKUSDT',
	'CREAMUSDT',
	'GFTUSDT',
	'IQUSDT',
	'FDUSDTRY',
	'NTRNUSDT',
	'TIAUSDT',
	'MEMEUSDT',
	'ORDIUSDT',
	'BEAMXUSDT',
	'PIVXUSDT',
	'VICUSDT',
	'BLURUSDT',
	'VANRYUSDT',
	'AEURUSDT',
	'JTOUSDT',
	'1000SATSUSDT',
	'BONKUSDT',
	'ACEUSDT',
	'NFPUSDT',
	'AIUSDT',
	'XAIUSDT',
	'MANTAUSDT',
	'ALTUSDT',
	'JUPUSDT',
	'PYTHUSDT',
	'RONINUSDT',
	'DYMUSDT',
	'PIXELUSDT',
	'STRKUSDT',
	'PORTALUSDT',
	'PDAUSDT',
	'AXLUSDT',
	'WIFUSDT',
	'METISUSDT',
	'AEVOUSDT',
	'BOMEUSDT',
	'ETHFIUSDT',
	'ENAUSDT',
	'WUSDT'
];
